import type { AdnContext } from '../../../types/global';

const DEFAULT_TIMEOUT_IN_MILLISECONDS = 4000;

/**
 * Resolves the Aftonbladet `se-generic-loggedin` login state, shared by the
 * classic ADN adapter and the VMAP path.
 *
 * Waits for identity to resolve (up to 4s) so that the keyword reflects the
 * user's actual login state. Falls back to "not logged in" if identity
 * hasn't resolved by the timeout, matching the same budget used for consent
 * and token requests.
 */
export async function resolveIsLoggedIn(
  context: Pick<AdnContext, 'identityHelper'>
): Promise<boolean> {
  await context.identityHelper?.waitForInitialization(
    DEFAULT_TIMEOUT_IN_MILLISECONDS
  );

  return Boolean(context.identityHelper?.getUserId());
}
